(() => {
  const container = document.querySelector('.rb-giveaway__form');
  if (!container) return;
  const css = `
    :host { --forms-base-font-size:16px; --forms-body-font:normal 400 16px Arial,sans-serif; --forms-base-font-line-height:1.6; --container-text-alignment:left; --form-text-color:#080808; --form-placeholder-color:#454545; }
    #app-embed :is(p,legend,label,span) { line-height:1.6; }
    #app-embed [data-testid="form"] + div { color:#fff; font-size:14px; line-height:1.65; text-align:left; }
    #app-embed [data-testid="form"] + div :is(p,a) { font-size:inherit; line-height:inherit; color:inherit; }
    #app-embed input:not([type="checkbox"]):not([type="radio"]) { font-size:16px; color:#080808; background:#fff; }
    #app-embed button[type="submit"] { min-height:52px; font-size:16px; line-height:1.4; font-weight:700; color:#080808; background:#c6b38e; }
    #app-embed :is(input,button,a):focus-visible { outline:3px solid #c6b38e; outline-offset:3px; }
  `;
  let connected = false;
  const apply = () => {
    const host = container.querySelector('shopify-forms-embed');
    const root = host?.shadowRoot;
    if (!root) return;
    if (!root.querySelector('style[data-rb-readable]')) {
      const style = document.createElement('style');
      style.dataset.rbReadable = '';
      style.textContent = css;
      root.append(style);
    }
    if (!connected) {
      connected = true;
      new MutationObserver(apply).observe(root, {childList:true});
    }
  };
  new MutationObserver(apply).observe(container, {childList:true,subtree:true});
  customElements.whenDefined('shopify-forms-embed').then(apply);
  apply();
})();
